import Activity from "@/models/api/activity/Activity";
import ActivityRegistrationRequest from "@/models/api/activity/ActivityRegistrationRequest";
import AssociationActivity from "@/models/api/association/AssociationActivity";

import axios, { AxiosResponse } from "axios";
class Service {
    public async GetActivities(): Promise<AxiosResponse<Activity[]>> {
        return axios.get('api/activity/GetActivities/');
    }
    public async GetActivity(id: number): Promise<AxiosResponse<Activity>> {
        return axios.get(`api/activity/GetActivity?id=${id}`);
    }  
    public async GetAssociationActivities(): Promise<AxiosResponse<AssociationActivity[]>> {
        return axios.get(`api/activity/GetAssociationActivities/`);
    }

    public async RegisterActivity(activityData: ActivityRegistrationRequest): Promise<AxiosResponse<any>> {
        return axios.post("api/activity/RegisterActivity", activityData);
    }
    public async EditActivity(activity: Activity): Promise<AxiosResponse<any>> {
        return axios.post("api/activity/EditActivity", activity);
    }
    public async RemoveActivity(id: number): Promise<AxiosResponse<any>> {
        return axios.delete(`api/activity/RemoveActivity?id=${id}`);
    }
  
    public async GetActivitiesAndSelectedAssociationActivities(associationId?: number | null): Promise<AxiosResponse<AssociationActivity[]>> {

        if (associationId) {
            return axios.get(`api/activity/GetActivitiesAndSelectedAssociationActivities/?associationId=${associationId}`);
        }

        return axios.get(`api/activity/GetActivitiesAndSelectedAssociationActivities/`);

    }
}

export const ActivityService: Service = new Service();
